import { useEffect, useRef, useState } from "react";

/**
 * useLiveAnnounce — returns [message, announce()] and a node to render
 * inside the form. The node carries aria-live="polite" so assistive tech
 * reads success and error messages.
 */
export function useLiveAnnounce() {
    const [message, setMessage] = useState("");
    const timeoutRef = useRef(null);

    const announce = (text) => {
        // Clearing first ensures the assistive layer re-reads identical
        // messages submitted in quick succession.
        setMessage("");
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => setMessage(text), 60);
    };

    useEffect(() => {
        return () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, []);

    return { message, announce };
}

export function LiveRegion({ message }) {
    return (
        <div
            role="status"
            aria-live="polite"
            aria-atomic="true"
            className="sr-only"
        >
            {message}
        </div>
    );
}
